import { useEffect, useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import Chip from '@mui/material/Chip';

import LicenseInfo from './LicenseInfo';

const Licenses = () => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'License Id',
      },
//      {
//        accessorKey: 'severity',
//        header: 'Severity',
//        accessorFn: (rowData) => {
//          if (rowData.severity === 'high') {
//            return <Chip label="High" color="error"/>
//          } else if (rowData.severity === 'medimum') {
//            return <Chip label="Medium" color="yellow"/>
//          } else {
//            return <Chip label="None" color="primary" variant="outlined" />
//          }
//        }
//      },
//      {
//        accessorKey: 'instructions',
//        header: 'Instructions',
//        accessorFn: (rowData) => {
//          return rowData.instructions ? rowData.instructions : 'No instructions for this license'
//        }
//      },
      {
        accessorKey: 'dependencies_count',
        header: 'Total Dependencies',
        accessorFn: (rowData) => {
          return <Chip style={{width:'50px',fontWeight:'bold'}} label={rowData.dependencies.length} color="primary" variant="outlined" />
        }
      },
      {
        accessorKey: 'projects_count',
        header: 'Total Projects',
        accessorFn: (rowData) => {
          return <Chip style={{width:'50px',fontWeight:'bold'}} label={rowData.projects.length} color="primary" variant="outlined" />
        }
      },
    ],
    [],
  );

  //data and fetching state
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const fetchData = async () => {
    if (!data.length) {
      setIsLoading(true);
    } 

    // const url = new URL(
    //   '/snyk-to-html/api/get_report', 'https://licenses.happymoney.com');

    //did not work
    // const API_BASE = process.env.REACT_APP_API_BASE_URL;
    // const url = new URL(
    //   '/snyk-to-html/api/get_report',
    //   API_BASE
    // );
    const url = new URL(
  '/snyk-to-html/api/get_report',
  window.location.origin
);


//    url.searchParams.set(
//      'start',
//      `${pagination.pageIndex * pagination.pageSize}`,
//      );
//    url.searchParams.set('size', `${pagination.pageSize}`);

    try {
      const response = await fetch(url.href);
      const json = await response.json();
      setData(json.results);
    } catch (error) {
      console.error(error);
      return;
    }
    setIsLoading(false);
  };
  
  //if you want to avoid useEffect, look at the React Query example instead
  useEffect(() => {
    fetchData();
  }, []);
  
  const table = useMaterialReactTable({
    columns,
    data,
    enableTopToolbar: false,
    enablePagination: false,
    enableStickyHeader: true,
    initialState: { expanded: true },
    renderDetailPanel: ({ row }) => {
      return <LicenseInfo projects={row.original.projects} dependencies={row.original.dependencies}/>
    },
    muiTableHeadCellProps: {
      sx: (theme) => ({
        background: '#000',
        color: '#fff'
      }),
    },
    muiTableBodyRowProps: ({ isDetailPanel, row, table }) => {
      return {
        hover: false,
        sx: {
          backgroundColor: isDetailPanel ? '#fff' : 'rgba(167, 166, 166, 0.18)',
        }
      };
    },
    enableSorting: false,
    state: {
      isLoading
    }
  });

  return <MaterialReactTable table={table} />;
};

export default Licenses;